/* eslint-disable react/no-unstable-nested-components */
/* eslint-disable react-native/no-inline-styles */
import React, { useEffect, useState } from 'react';
import { Divider, IconButton, List, Text } from 'react-native-paper';
import { FlatList, StyleSheet, View } from 'react-native';
import { SafeAreaView } from 'react-native-safe-area-context';
import Modal from 'react-native-modal';
import { modalConatiner, modalHeader, theme } from '../theme/theme';

const OrderItemsModal = ({ visible, tempOrder, onClose }) => {
    const [isModalVisisble, setModalVisible] = useState(visible);

    useEffect(() => {
        setModalVisible(visible);
    }, [visible]);

    const closeModal = () => {
        setModalVisible(false);
        if (onClose) {
            onClose(false);
        }
    };

    // const renderItem = ({ item, index }) => <List.Item onPress={() => onOrderStatusClick({ item, index })} title={item?.label} titleStyle={{ fontSize: 14 }} />;
    const renderItem = ({ item, index }) => (
        <List.Item title={item?.item_name} right={props => (
            <Text style={{ fontSize: 14 }}>
                {item?.item_qty} X {tempOrder?.currency_symbol}{item?.item_price}
            </Text>
        )} />
    );

    return (
        <Modal
            coverScreen={true}
            animationIn="slideInUp"
            animationOut="slideOutDown"
            animationInTiming={300}
            animationOutTiming={250}
            backdropTransitionInTiming={300}
            backdropTransitionOutTiming={250}
            hideModalContentWhileAnimating={true}
            isVisible={isModalVisisble}
            onBackButtonPress={closeModal}
            onBackdropPress={closeModal}
            style={modalConatiner}>
            <SafeAreaView style={styles.modalView}>
                <View style={[modalHeader, { backgroundColor: theme.colors.primary }]}>
                    <Text variant="titleMedium" style={{ color: theme.colors.onPrimary }}>OrderId: #{tempOrder?.order_code} items</Text>
                    <IconButton icon="close"
                        onPress={closeModal}
                        iconColor={theme.colors.onPrimary}
                        size={20} />
                </View>
                <Divider />
                <View style={{ overflow: 'auto', flex: 1 }}>
                    <FlatList
                        data={tempOrder.order_items || []}
                        renderItem={renderItem}
                        showsVerticalScrollIndicator={true}
                        keyExtractor={(item, index) => (index).toString()}
                        ItemSeparatorComponent={<Divider style={{ marginHorizontal: 6 }} />}
                    />
                </View>
            </SafeAreaView>
        </Modal>
    );
};

const styles = StyleSheet.create({
    modalView: {
        flex: 1,
        maxHeight: '60%',
        backgroundColor: '#ffffff',
        borderRadius: 16,
        margin: 6,
    },
});

export default OrderItemsModal;

